import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Solutions from "../pages/solutions/page";
import SolutionDetail from "../pages/solutions/detail/page";
import ProjectDetail from "../pages/projects/detail/page";
import Contact from "../pages/contact/page";
import PrivacyPolicy from "../pages/privacy-policy/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/solutions", element: <Solutions /> },
  { path: "/solutions/:slug", element: <SolutionDetail /> },
  { path: "/projects/:slug", element: <ProjectDetail /> },
  { path: "/contact", element: <Contact /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "*", element: <NotFound /> },
];

export default routes;